import cx from "classnames";
import { Link } from "react-router-dom";
import { Wrapper } from "../styled/styled-components";
import { Context, IContext } from "../../context/ContextApp";
import { useContext } from "react";
import Icon from "../Icon/icon";
import MinusIcon from "../../assets/minusIcon";
import PlusIcon from "../../assets/plus";
import ExternalLink from "../../assets/externalLink";
import Tooltip from "../Tooltip/Tooltip";
import { subdomainTypes } from "../../context/availableSubdomains";
import { CATEGORIES, webData } from "./data";

interface Props {
  webstoreExpanded: boolean;
  currentCategory: string;
  setCurrentCategory: React.Dispatch<React.SetStateAction<string>>;
  setWebstoreExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const WebstoreMenu = ({
  webstoreExpanded,
  currentCategory,
  setCurrentCategory,
  setWebstoreExpanded,
}: Props) => {
  const { appBranch }: IContext = useContext(Context);
  const webstoreMenuLinks = CATEGORIES;
  const allowedWebDataLinks: string[] = [subdomainTypes.AU, subdomainTypes.NZ];
  const WebDataMenuLinks = webData;

  const returnLinks = () =>
    webstoreMenuLinks.map((item, index) =>
      item.isExternalLink && appBranch !== subdomainTypes.CA ? (
        <a className="icons" href={item.link} target="_blank" key={index}>
          <Wrapper style={{ width: "15%" }}>
            <Icon name={item.icon} />
          </Wrapper>
          <Tooltip
            tooltipClassName="tooltip"
            content={
              "Check out our NEW Media Library layout, with everything you need in one easy-to-navigate location"
            }
          >
            {item.title}
          </Tooltip>
          <div className="expand-icon" style={{ marginRight: "0.5rem" }}>
            <ExternalLink width={15} fill="white" />
          </div>
        </a>
      ) : (
        <Link
          key={index}
          className={cx({
            selected: webstoreExpanded && currentCategory === item.category,
            icons: true,
          })}
          to={item.route}
          onClick={() => {
            setCurrentCategory(item.category);
          }}
        >
          <Wrapper style={{ width: "15%" }}>
            <Icon name={item.icon} />
          </Wrapper>
          {item.title === "Consolidated Media Library"
            ? "Media Library"
            : item.title}
        </Link>
      )
    );

    const returnWebDataLinks = () =>
      WebDataMenuLinks.map((item, index) =>
        <a className="icons" href={item[appBranch === subdomainTypes.AU ? "linkAU" : "linkNZ"]} target="_blank" key={index}>
          <Wrapper style={{ width: "15%" }}>
            <Icon name={item.icon} />
          </Wrapper>
            {item.title}
          <div className="expand-icon" style={{ marginRight: "0.5rem" }}>
            <ExternalLink width={15} fill="white" />
          </div>
        </a>
    );

  return (
    <div className="sidebar-menu">
      <div
        className="menu-label"
        onClick={() => setWebstoreExpanded(!webstoreExpanded)}
      >
        Webstore
        <div className="expand-icon">
          {webstoreExpanded ? (
            <MinusIcon width={10} fill="white" />
          ) : (
            <PlusIcon width={10} fill="white" />
          )}
        </div>
      </div>
      {webstoreExpanded && <div className="sub-menu">{returnLinks()}{allowedWebDataLinks.includes(appBranch) && returnWebDataLinks()}</div>}
    </div>
  );
};

export default WebstoreMenu;
